import { signal } from "@preact/signals-react";
import useLocalStorage from "./useLocalStorage"

export const accessToken = signal('')
export default function useAccessToken() {

    function getInitialValue() {
        accessToken.value = useLocalStorage('accessToken', '').value
    }

    getInitialValue()
    return accessToken
}